export interface SkinUiTeardownOptions {
    button: HTMLElement;
    dropdown: HTMLElement;
    overlayWrapper: HTMLElement;
    overlay: HTMLImageElement;
    canvas: HTMLCanvasElement;
    outsideClickHandler: (event: MouseEvent) => void;
    inputHandler: (event: Event) => void;
    clearOverlay: () => void;
    removeSceneListeners: () => void;
}

/**
 * Build the single teardown used for virtual-staging UI on both viewer destroy
 * and in-place portal navigation. The returned function is deliberately
 * idempotent because both paths can touch the same viewer during a transition.
 */
export function createSkinUiTeardown(options: SkinUiTeardownOptions): () => void {
    let cleanedUp = false;

    return () => {
        if (cleanedUp) return;
        cleanedUp = true;

        // clearOverlay cancels its pending image load callback and clears the
        // active staging state before the old scene is discarded.
        try { options.clearOverlay(); } catch { /* scene teardown must continue */ }

        options.dropdown.classList.remove('open');
        options.button.classList.remove('active');
        options.overlayWrapper.classList.remove('active');
        options.dropdown.querySelectorAll('.storysplat-skin-item.loading').forEach((item) => {
            item.classList.remove('loading');
        });

        document.removeEventListener('click', options.outsideClickHandler);
        options.canvas.removeEventListener('pointerdown', options.inputHandler);
        options.canvas.removeEventListener('wheel', options.inputHandler);
        window.removeEventListener('keydown', options.inputHandler);
        options.removeSceneListeners();

        // Abort any image still loading and remove every staging DOM root. The
        // dropdown and overlay live outside the toolbar, so toolbar removal alone
        // is not sufficient when a new scene reuses this container.
        options.overlay.removeAttribute('src');
        options.button.remove();
        options.dropdown.remove();
        options.overlayWrapper.remove();
    };
}
